export default "__VITE_ASSET__DwIOBtXp__"